import _styled, { default as _styled2 } from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@adsk/alloy-react-checkbox';
import theme from '@adsk/alloy-react-theme';
const Overlay = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    defaultSelected,
    selected,
    badge,
    onChange,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    ref: ref,
    $_css: [{
      width: '100%',
      justifyContent: 'space-between',
      display: 'flex'
    }]
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    className: "checkbox",
    defaultChecked: defaultSelected,
    checked: selected,
    inputProps: {
      onChange,
      onClick: e => e.stopPropagation()
    },
    style: {
      cursor: 'default',
      opacity: selected ? 1 : 0
    },
    "data-testid": 'Tile__checkbox'
  })), badge && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      background: theme.tokens.colors.background.accent.six.bold.value,
      color: theme.tokens.colors.text.inverse.value,
      borderRadius: theme.borderRadius.pill,
      padding: `${theme.spacing.XXXS}px ${theme.spacing.XS}px`
    }, theme.typography.labelMedium]
  }, badge));
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /** Class applied to the root element */
  className: PropTypes.string,
  /** If Tile is selected. */
  selected: PropTypes.bool,
  /** If Tile is selected by default.  Defaults to false */
  defaultSelected: PropTypes.bool,
  /** onChange event handler. */
  onChange: PropTypes.func,
  /** The label content */
  badge: PropTypes.any
};
export default Overlay;
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  displayName: "Overlay___StyledDiv2",
  componentId: "sc-up7zql-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=Overlay.js.map